import { Tooltip, Card, Typography, Input, Button, Switch, Pagination, Form, Empty } from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect, useCallback } from "react";
import AddItemSensitivity from "../../Modal/AddItemSensitivity";
import SortingArrow from "../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import { changeLoader } from "../../redux/reducers/loader";
import {
  checkPermissionAction,
  formatDateFunction,
} from "../../utils/helper/utils";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";

let timer = null;

const ManageItemSensitivity = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [addItemSensitivity, setAddItemSensitivity] = useState(false);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(null);
  const [editMode, setEditMode] = useState(false);

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }
  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
    setItemData(null);
  };
  const handleAddItemSensitivityCancel = () => {
    setAddItemSensitivity(false);
    setEditMode(false);
    setItemData(null);
  };

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllItemSensitivity = useCallback(async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_ITEM_SENSITIVITY.GET_ALL_ITEM_SENSITIVITY,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data);
        setTotalRows(apiResponse?.data?.paginator?.itemCount);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  },[ dispatch, inputData, paginationModel?.page, paginationModel?.limit]);

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllItemSensitivity();
    }, 400);
  }, [getAllItemSensitivity, inputData, paginationModel]);

  const handleStatusOrDelete = async (item, newStatus) => {
    try {
      let response = await globalRequest(
        Apis?.MANAGE_ITEM_SENSITIVITY?.UPDATE_STATUS + "/" + item.id,
        "put",
        { status: newStatus },
        {},
        true
      );

      if (response?.status === 200) {
        let msg =
          newStatus === "active"
            ? "Item Sensitivity activated successfully"
            : newStatus === "inactive"
            ? "Item Sensitivity deactivated successfully"
            : "Item Sensitivity deleted successfully";

        toast.success(msg, { duration: 2000 });
        setItemData(null);
        getAllItemSensitivity();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const handleSaveItemSensitivity = async (values) => {
    try {
      let payload = {
        title_en: values.title_en,
        title_ar: values.title_ar,
        user_id: 1,
      };

      let response;
      if (editMode && itemData?.id) {
        response = await globalRequest(
          Apis.MANAGE_ITEM_SENSITIVITY.EDIT_ITEM_SENSITIVITY + "/" + itemData.id,
          "put",
          payload,
          {},
          true
        );
      } else {
        response = await globalRequest(
          Apis.MANAGE_ITEM_SENSITIVITY.CREATE_ITEM_SENSITIVITY,
          "post",
          payload,
          {},
          true
        );
      }

      if (response?.status === 200) {
        toast.success(`Item Sensitivity ${editMode ? "updated" : "created"} successfully!`);
        handleAddItemSensitivityCancel();
        getAllItemSensitivity();
      } else {
        toast.error(response.data?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const handleEdit = (item) => {
    if (checkPermissionAction("Item Sensitivity", permissionJson, "edit")) {
      setItemData(item);
      setEditMode(true);
      setAddItemSensitivity(true);
    }
  };

  const handleDelete = (item) => {
    if (checkPermissionAction("Item Sensitivity", permissionJson, "delete")) {
      setIsDeleteModalOpen(true);
      setItemData(item);
    }
  };

 const handleDeleteOk = () => {
    if (!itemData?.id) return;

    if (checkPermissionAction("Item Sensitivity", permissionJson, "delete")) {
      handleStatusOrDelete(itemData, "deleted");
      setIsDeleteModalOpen(false);
    } else {
      toast.error("You don't have permission to delete this item.");
    }
  };

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between	mb-4 gap-5">
          <div className="">
            <Typography className="text-xl font-semibold" align={"left"}>
              Manage Item Sensitivity
            </Typography>
          </div>
          <div>
            <Search
              placeholder="Search by Item sensitivity"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                form.setFieldValue("search", value);
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
              style={{
                width: window.innerWidth < 768 ? "100%" : 300,
              }}
              className="mx-1.5 cursor-pointer my-3 sm:my-0"
            />
            {checkPermissionAction(
              "Item Sensitivity",
              permissionJson,
              "add"
            ) ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="mx-1.5 cursor-pointer"
                onClick={() => {
                  setEditMode(false);
                  setItemData(null);
                  setAddItemSensitivity(true);
                }}
              >
                Add Item sensitivity
              </Button>
            ) : null}
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full  text-left	 text-sm  text-gray-500">
            <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Item Sensitivity{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("name", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Created Date & Time{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("createdAt", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3">
                  Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3 text-center whitespace-nowrap vertical-top"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top">{item?.locales?.find((loc) => loc.languageCode === (localStorage.getItem("lang") || "en"))?.name || "-"}</td>
                    <td className="px-3 py-4 vertical-top">
                      {formatDateFunction(item.createdAt, "dd-mm-yyyy", true)}
                    </td>
                    <td className="px-3 py-4 vertical-top">
                      <Switch
                        checked={item?.status === "active"}
                        onChange={() => handleStatusOrDelete(item, item.status === "active" ? "inactive" : "active")}
                        disabled={!checkPermissionAction("Item Sensitivity", permissionJson, "update_status")}
                      />
                    </td>
                    <td className="px-3 py-4 text-center whitespace-nowrap vertical-top">
                      <Tooltip title="Edit">
                        <EditOutlined
                          onClick={() => handleEdit(item)}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Item Sensitivity",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction("Item Sensitivity", permissionJson, "delete")
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => handleDelete(item)}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center mt-3">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>
      {/* delete modal */}
      <ConfirmationModal
        ConfirmationHeading="Delete"
        ConfirmationParagraph="Are you sure you want to delete this Item Sensitivity?"
        isOpen={isDeleteModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleDeleteCancel}
      />
      <AddItemSensitivity
        isOpen={addItemSensitivity}
        onOk={handleSaveItemSensitivity}
        onCancel={handleAddItemSensitivityCancel}
        editMode={editMode}
        itemData={itemData}
        form={form}
      />
    </>
  );
};
export default ManageItemSensitivity;
